import { ChainID } from '@jdiyield/constants'
import Web3 from 'web3'

import getNodeUrl from '../rpcRandom'
import { makeBatchRequest } from '../utils'

export const getApeAPR = async (
  contractAddress: string,
  functionRewardPerBlockName: string,
  poolId: number,
  chainID: ChainID
): Promise<{
  rewardPerBlock: string
  multiplier: string
  allocPoints: string
  totalAllocPoints: string
}> => {
  if (!functionRewardPerBlockName) return null //// *** return null when functionRewardPerBlockName not have value ***
  try {
    const RPC_URL = getNodeUrl(chainID)
    const web3 = await new Web3(RPC_URL)
    const { miniChefGenABI } = await import('@jdiyield/abi')
    const ct = new web3.eth.Contract(
      miniChefGenABI({ rewardPerBlock: functionRewardPerBlockName }) as any,
      contractAddress
    )
    const [poolInfo, rewardPerBlock] = await makeBatchRequest(web3, [
      ct.methods.poolInfo(poolId).call,
      ct.methods[`${functionRewardPerBlockName}`]().call
    ])

    const allocPoints = poolInfo[2]
    const totalAllocPoints =
      (await ct.methods
        .totalAllocPoint()
        .call()
        .catch(() => allocPoints)) || +allocPoints

    return {
      rewardPerBlock,
      multiplier: '2',
      allocPoints,
      totalAllocPoints
    }
  } catch (error) {
    console.log('getApeAPR', contractAddress, error)
  }
}
